import { infiniteListPageSize } from "../models/consts";
import { Base } from "./base";

export interface IListItems<T> {
    items: T[];
    hasMore: boolean;
    page: number;
    //For preloaded data
    pageSize: number;
    sortColumn: string;
    sortOrderIsAsc: boolean;
}

export class ListItems<I> implements IListItems<I> {
    items: I[];
    hasMore: boolean;
    page: number;
    //For preloaded data
    pageSize: number;
    sortColumn: string;
    sortOrderIsAsc: boolean;

    constructor();
    constructor(obj: IListItems<I>);
    constructor(obj?: any) {
        this.hasMore = obj && obj.hasMore || false;
        this.page = obj && obj.page || 1;
        this.pageSize = obj && obj.pageSize || infiniteListPageSize;
        this.sortColumn = obj && obj.sortColumn || "";
        this.sortOrderIsAsc = obj && obj.sortOrderIsAsc || false;
        this.items = [];
    }
    
    static create<T>(type: (new (...args: any[]) => T), ...obj: any): ListItems<T> {
        const result = new ListItems<T>(obj);
        result.items = Base.getTypedArray<T>(obj ? obj.items : null, type);
        return result;
    };
}